module.exports = __webpack_public_path__ + "img/candycane.7f9e5e20.svg";